// Form Builder (branded forms + submissions) action types

export const FORMS_LIST = "FORMS_LIST";
export const FORMS_LIST_SUCCESS = "FORMS_LIST_SUCCESS";
export const FORMS_LIST_FAILURE = "FORMS_LIST_FAILURE";

export const FORMS_RENDER = "FORMS_RENDER";
export const FORMS_RENDER_SUCCESS = "FORMS_RENDER_SUCCESS";
export const FORMS_RENDER_FAILURE = "FORMS_RENDER_FAILURE";

export const FORMS_SAVE = "FORMS_SAVE";
export const FORMS_SAVE_SUCCESS = "FORMS_SAVE_SUCCESS";
export const FORMS_SAVE_FAILURE = "FORMS_SAVE_FAILURE";

export const FORMS_PUBLISH = "FORMS_PUBLISH";
export const FORMS_PUBLISH_SUCCESS = "FORMS_PUBLISH_SUCCESS";
export const FORMS_PUBLISH_FAILURE = "FORMS_PUBLISH_FAILURE";

export const FORMS_UNPUBLISH = "FORMS_UNPUBLISH";
export const FORMS_UNPUBLISH_SUCCESS = "FORMS_UNPUBLISH_SUCCESS";
export const FORMS_UNPUBLISH_FAILURE = "FORMS_UNPUBLISH_FAILURE";

// Task 24888 - the company's own form statuses, and moving a form onto one.
export const FORM_STATUS_LIST = "FORM_STATUS_LIST";
export const FORM_STATUS_LIST_SUCCESS = "FORM_STATUS_LIST_SUCCESS";
export const FORM_STATUS_LIST_FAILURE = "FORM_STATUS_LIST_FAILURE";

export const FORM_STATUS_CREATE = "FORM_STATUS_CREATE";
export const FORM_STATUS_CREATE_SUCCESS = "FORM_STATUS_CREATE_SUCCESS";
export const FORM_STATUS_CREATE_FAILURE = "FORM_STATUS_CREATE_FAILURE";

export const FORM_STATUS_UPDATE = "FORM_STATUS_UPDATE";
export const FORM_STATUS_UPDATE_SUCCESS = "FORM_STATUS_UPDATE_SUCCESS";
export const FORM_STATUS_UPDATE_FAILURE = "FORM_STATUS_UPDATE_FAILURE";

export const FORM_STATUS_DELETE = "FORM_STATUS_DELETE";
export const FORM_STATUS_DELETE_SUCCESS = "FORM_STATUS_DELETE_SUCCESS";
export const FORM_STATUS_DELETE_FAILURE = "FORM_STATUS_DELETE_FAILURE";

export const FORMS_SET_STATUS = "FORMS_SET_STATUS";
export const FORMS_SET_STATUS_SUCCESS = "FORMS_SET_STATUS_SUCCESS";
export const FORMS_SET_STATUS_FAILURE = "FORMS_SET_STATUS_FAILURE";

export const FORMS_DUPLICATE = "FORMS_DUPLICATE";
export const FORMS_DUPLICATE_SUCCESS = "FORMS_DUPLICATE_SUCCESS";
export const FORMS_DUPLICATE_FAILURE = "FORMS_DUPLICATE_FAILURE";

export const FORMS_DELETE = "FORMS_DELETE";
export const FORMS_DELETE_SUCCESS = "FORMS_DELETE_SUCCESS";
export const FORMS_DELETE_FAILURE = "FORMS_DELETE_FAILURE";

export const FORMS_SUBMISSIONS = "FORMS_SUBMISSIONS";
export const FORMS_SUBMISSIONS_SUCCESS = "FORMS_SUBMISSIONS_SUCCESS";
export const FORMS_SUBMISSIONS_FAILURE = "FORMS_SUBMISSIONS_FAILURE";

export const FORMS_SUBMISSION_DATA = "FORMS_SUBMISSION_DATA";
export const FORMS_SUBMISSION_DATA_SUCCESS = "FORMS_SUBMISSION_DATA_SUCCESS";
export const FORMS_SUBMISSION_DATA_FAILURE = "FORMS_SUBMISSION_DATA_FAILURE";
